import { fakerRU as faker } from '@faker-js/faker';

export const signInMock = {
  User: {
    Username: 'demo',
    Id: '00000000-0000-0000-0000-000000000000',
    Role: 'clients',
    Groups: [
      {
        GroupName: 'ru',
        Description: 'Россия',
        Country: 'ru',
        CreatedAt: '2025-06-20T08:42:01.979Z'
      }
    ],
    IsSub: false,
    Enabled: true,
    UserStatus: 'CONFIRMED',
    LastVisit: new Date().toISOString(),
    Online: true,
    EmailVerified: true,
    Phone: '+70000000000',
    Email: faker.internet.email({ provider: 'example.org' }),
    Emails: [faker.internet.email({ provider: 'example.org' })],
    Name: faker.person.firstName(),
    GivenName: faker.person.middleName(),
    FamilyName: faker.person.lastName(),
    Company: faker.company.name(),
    Bin: '123123123123',
    Blocks: [],
    Privileges: ['updateDevice', 'manageHwt', 'manageHwt:updatePaymentDate']
  },
  Token: faker.internet.jwt(),
  AccessToken: faker.internet.jwt(),
  Refresh: faker.internet.jwt()
};

export const bonusesMock = { status: 'ok', t: 1755800287371, result: false };
